import React from 'react';
import { ProgressBarContainer, ProgressBarFill } from './Styled';

interface ProgressBarProps {
    value: number;
    fillColor: string;
}

const ProgressBar = ({
    value,
    fillColor,
}: ProgressBarProps) => {
    const clampedValue = Math.min(Math.max(value, 0), 100);

    return (
        <ProgressBarContainer
            fillColor={fillColor}
        >
            <ProgressBarFill
                width={`${clampedValue}%`}
                fillColor={fillColor}
            />
        </ProgressBarContainer>
    );
};

export default ProgressBar;
